export default __webpack_public_path__ + "static/champion-htf-welterweight-webfont-b6e2dc4615690c8a7ec78b0d685ca42e.woff";